// OTC sales channels
export const OTC_SALES_CHANNEL_IDS = [
  'otc_branch1-kfzteile24-de',
  'otc_branch2-kfzteile24-de',
  'otc_branch3-kfzteile24-de',
];

export function isOtcSalesChannelId(id) {
  return OTC_SALES_CHANNEL_IDS.includes(id);
}

// Extract branch number (1-3)
// Pattern: otc_branch{N}-kfzteile24-de => returns N or '' if not valid (1..3)
export function extractWhsFromOtcSalesChannelId(id) {
  if (typeof id !== 'string') return '';
  const match = id.match(/otc_branch(\d+)-/);
  if (!match) return '';
  const n = match[1];
  return ['1', '2', '3'].includes(n) ? n : '';
}
